// API URL helper for production and development compatibility
export const getApiUrl = () => {
  // Check if we're in development (localhost)
  const isDevelopment = window.location.hostname === 'localhost' || 
                        window.location.hostname === '127.0.0.1';
  
  // In development, use the preview URL if available, otherwise construct from port 8001
  if (isDevelopment) {
    // For local development, backend runs on port 8001
    return 'http://localhost:8001/api';
  }
  
  // In production, use the current origin (same domain)
  return `${window.location.origin}/api`;
};

export const API = getApiUrl();
